import { appContext } from "../../../../AppContext";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { PagedResponse } from "@iconics/core";
import { Solution } from "./DataModels";
import IbssHomeCard from "../../../../Components/Cards/HomePageCard/IbssHomeCard";
import { JSX } from "react";
import { IRouterProps, withRouting } from "@iconics/components";
import { Card, GridContainer, GridItem, LayoutContainer, LayoutContent } from "@iconics/components";

class Home extends IbssPage<IProps, IState>
{
    private userCanReadSolutions = false;

    constructor(props: IProps)
    {
        const { localStorageProvider } = appContext();
        super(props);
        this.state = {
            solutions: [],
        };
        this.userCanReadSolutions = localStorageProvider.hasRight('DATAMODEL.Solutions.Read');
    }

    public async componentDidMount(): Promise<void>
    {
        const labels = appContext().labels;
        this.pageTitle = labels.Platform_Home_PageTitle;
        if (this.userCanReadSolutions)
        {
            const solutionsData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.get<PagedResponse<Solution[]>>({
                select: Solution,
                tenancy: appContext().tenantId,
                filter: `IsEnabled eq 'Yes' and ShowOnHomePage eq 'Yes' and ApplicationUri ne null and ApplicationUri ne ''`,
                orderBy: 'OrderSequence,Name',
            });

            const solutions = solutionsData.value.map(i => ({
                id: i.Id,
                name: i.Name,
                description: i.Description,
                imageUri: i.ImageUri ?? '',
                applicationUri: i.ApplicationUri,
            } as ISolution));

            this.setState({ solutions: solutions });
        }
    }

    private navigateToLink(url: string): void
    {
        if (url.startsWith('http'))
        {
            // if link is an absolute rather than relative, use browser to navigate to url instead of react-router.
            window.location.href = url;
        }
        else
        {
            this.props.navigate(url);
        }
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <>
                <LayoutContainer>
                    <LayoutContent>
                        <Card
                            title={labels.Platform_Home_DetailsTitle}
                            subTitle={labels.Platform_Home_DetailsSubTitle}
                        >
                            <GridContainer>
                                <GridItem>
                                    {labels.Platform_Home_Description}
                                </GridItem>
                                <GridItem>
                                    <GridContainer>
                                        {this.state.solutions.map(i =>
                                            <GridItem
                                                expanded={6}
                                                key={i.id}
                                            >
                                                <IbssHomeCard
                                                    imageSource={i.imageUri}
                                                    imageAlt={i.name}
                                                    title={i.name}
                                                    description={i.description}
                                                    href={i.applicationUri}
                                                    onClick={i => this.navigateToLink(i)}
                                                />
                                            </GridItem>
                                        )}
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </LayoutContent>
                </LayoutContainer>
            </>
        );
    }
}

export default withRouting(Home);

export interface IProps extends IRouterProps
{
}

export interface IState
{
    solutions: ISolution[];
}

export interface ISolution
{
    id: string;
    name: string;
    description: string;
    imageUri: string;
    applicationUri: string;
}
